import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "date-time",
  "use": "date-time-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"date-time\"><path fill-rule=\"evenodd\" d=\"M16.5 13v2.82l2.44 1.41-.75 1.3L15 16.69V13h1.5ZM5 8v11h4.67c-.43-.91-.67-1.93-.67-3a7 7 0 0 1 7-7c1.07 0 2.09.24 3 .67V8H5ZM3 19V5c0-1.11.89-2 2-2h1V1h2v2h8V1h2v2h1a2 2 0 0 1 2 2v6.1c1.24 1.26 2 2.99 2 4.9a7 7 0 0 1-7 7c-1.91 0-3.64-.76-4.9-2H5a2 2 0 0 1-2-2Zm13-7.85a4.85 4.85 0 1 0 0 9.7 4.85 4.85 0 0 0 0-9.7Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol